import { render } from "./practice-people.html?vue&type=template&id=c0316eec&scoped=true&ts=true&external"
import script from "./practice-people.ts?vue&type=script&lang=ts&external"
export * from "./practice-people.ts?vue&type=script&lang=ts&external"

import "./practice-people.scss?vue&type=style&index=0&id=c0316eec&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0316eec"]])

export default __exports__